export enum CartDispatchTypes {
  FETCH_CART_ITEMS = 'FETCH_CART_ITEMS',
  ADD_CART_ITEM = 'ADD_CART_ITEM',
  ADD_CART_ITEM_EXIST = 'ADD_CART_ITEM_EXIST',
  INCREASE_ITEM_QUANTITY = 'INCREASE_ITEM_QUANTITY',
  DECREASE_ITEM_QUANTITY = 'DECREASE_ITEM_QUANTITY',
  REMOVE_ITEM = 'REMOVE_ITEM',
  CALCULATE_SUM = 'CALCULATE_SUM',
  CLEAR_CART = 'CLEAR_CART'
}
